<div class="group h-full w-full">
    <ribbon *ngIf="ribbon" [status]="ribbonStatus">{{ ribbonTonLocalize() }}</ribbon>

    <vg-image *ngIf="logo" [image]="logo" [skeleton]="false" class="duration-300 filter-shadow !absolute !w-[80%] z-10 left-1/2" [ngClass]="[logoPositionCss, hovering ? 'group-hover:scale-[1.05]': '']"></vg-image>

    <div class="rounded overflow-hidden h-full">
        <vg-image [image]="background" class="!h-full !w-full" [skeleton]="false" placeholder="assets/images/placeholders/500x667.jpg"></vg-image>
    </div>
</div>